import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { WithdrawalSteps } from '@inyova/models';

@Component({
  selector: 'app-withdrawal-close',
  templateUrl: './withdrawal-close.component.html',
  styleUrls: ['./withdrawal-close.component.scss'],
  standalone: false
})
export class WithdrawalCloseComponent {
  @Input() parent: FormGroup;
  @Input() isMobileApp: boolean;
  @Output() prevStep: EventEmitter<void> = new EventEmitter<void>();
  @Output() nextStep: EventEmitter<WithdrawalSteps> = new EventEmitter<WithdrawalSteps>();
  @Output() trackActivity: EventEmitter<string> = new EventEmitter<string>();

  selectOptions: { value: boolean; title: string; desc: string }[] = [
    {
      value: true,
      title: 'ACCOUNT.withdrawalV2.account.radios.open.label',
      desc: 'ACCOUNT.withdrawalV2.account.radios.open.description'
    },
    {
      value: false,
      title: 'ACCOUNT.withdrawalV2.account.radios.close.label',
      desc: 'ACCOUNT.withdrawalV2.account.radios.close.description'
    }
  ];

  get keepAccountControl(): AbstractControl {
    return this.parent.get('keepAccount');
  }

  onKeepAccountChange(keepAccount: boolean) {
    this.keepAccountControl.setValue(keepAccount);
    this.trackActivity.emit(`[Button] New Withdrawal: ${keepAccount ? 'Keep' : 'Close'} account`);
  }

  onContinue() {
    this.nextStep.emit(WithdrawalSteps.SUMMARY);
  }

  onBack() {
    this.prevStep.emit();
  }
}
